/* This file is autogenerated, see readme.md for instructions */
import ArrowKeyboardNextSvgIcon from '@bloomreach/banana-theme/icons/arrow-keyboard-next.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const ArrowKeyboardNextIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <ArrowKeyboardNextSvgIcon />
    </Icon>
  );
});

ArrowKeyboardNextIcon.displayName = 'ArrowKeyboardNextIcon';

export default ArrowKeyboardNextIcon;
